<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-dict__dict}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.dictCode" placeholder="分类ID或分类名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('dict:dict:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('dict:dict:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="dictCode" label="分类ID" header-align="center" align="center"></el-table-column>
        <el-table-column prop="dictName" label="分类名字" header-align="center" align="center"></el-table-column>
        <el-table-column prop="sorts" label="排序" header-align="center" align="center" sortable></el-table-column>
        <el-table-column prop="type" label="类型" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type == 0" type="success">影视分类</el-tag>
            <el-tag v-if="scope.row.type == 1" type="success">小说分类</el-tag>
        </template>
        </el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('dict:dict:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.dictCode)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('dict:dict:delete')" type="text" size="small" @click="deleteHandle(scope.row.dictCode)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="refreshDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './dict-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/dict/dict/page',
        getDataListIsPage: true,
        exportURL: '/dict/dict/export',
        deleteURL: '/dict/dict',
        deleteIsBatch: true
      },
      dataForm: {
        dictCode: ''
      }
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
